export default __webpack_public_path__ + "static/SFMono-Semibold-6e6f6c93f4bdf9cbd090c60e97a017e2.woff2";